import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { ModalService } from './modal-service.service';
import { KeycloakCustomService } from './keycloak-custom.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate, CanLoad {

  constructor(private router: Router, private keycloak: KeycloakService, private keycloakCustom: KeycloakCustomService, private modalService: ModalService) { }

  async canActivate(): Promise<boolean> {
    return this.validateLogged();
  }
  async canLoad(): Promise<boolean> {
    return this.validateLogged();
  }

  async validateLogged() {

    const isLogged = await this.keycloak.isLoggedIn();
    const isLoggedSalesfoce = await this.keycloakCustom.isLoggin();

    if (!isLogged && !isLoggedSalesfoce) {
      const result = await this.modalService.openAlertNotLogged();
      if (result)
        this.router.navigate(['/profile'])
      else
        this.router.navigate(['/home']);
    }

    return isLogged || isLoggedSalesfoce;
  }
}
